import { render } from "./PatchNotesScreen.vue?vue&type=template&id=6bf8b24a&scoped=true&bindings={}"
import script from "./PatchNotesScreen.vue?vue&type=script&lang=ts"
export * from "./PatchNotesScreen.vue?vue&type=script&lang=ts"

import "./PatchNotesScreen.vue?vue&type=style&index=0&lang=scss"
import "./PatchNotesScreen.vue?vue&type=style&index=1&id=6bf8b24a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6bf8b24a"

export default script